import React, { useState } from "react";
import "./App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Reviews } from "./components/Reviews";
import { Footer } from "./components/Footer";
import { BookingForm } from "./components/BookingForm";
import { Calendar } from "./components/Calendar"; 

function App() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isCalOpen, setIsCalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  return (
    <div className="App">
      <Header onBookClick={() => setIsBookingOpen(true)} />
      <Hero onBookClick={() => setIsBookingOpen(true)} />
      <Services />
      <About />
      <Reviews />
      <Footer />
      <BookingForm isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} onNext={(formData) => {
        setFormData(formData);
        setIsCalOpen(true);
      }}/>
      <Calendar isOpen={isCalOpen} onClose={() => setIsCalOpen(false)}  formData={formData} />
      <Toaster position="top-right" />
      
      {/* Hidden trigger for About section CTA */}
      <button
        data-booking-trigger
        onClick={() => setIsBookingOpen(true)}
        className="hidden"
        aria-hidden="true"
      />
    </div>
  );
}

export default App;
